import React, { useMemo } from 'react'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'
import { IOfferModel } from './OfferModel'

type Props = {
  data: IOfferModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (item: IOfferModel) => void
  onDelete?: (item: IOfferModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}


type OfferRow = Omit<IOfferModel, 'id'> & { id?: string }

const toRow = (o: IOfferModel): OfferRow => ({
  ...o,
  id: o.id != null ? String(o.id) : undefined,
})

const fromRow = (r: OfferRow): IOfferModel =>
  ({ ...r, id: r.id != null ? Number(r.id) : null } as IOfferModel)

export const OfferTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const tableData = useMemo<OfferRow[]>(() => data.map(toRow), [data])

  const columns: TableColumn<OfferRow>[] = [
    { key: 'offerStatus',       label: 'Durum',                 className: 'fw-semibold', sortable: true },
    { key: 'offerSaleStatus',   label: 'Satış Durumu',                                  sortable: true },
    { key: 'reservationSource', label: 'Rezervasyon Kaynağı',                           sortable: true },
    { key: 'locations',         label: 'Lokasyonlar',                                    sortable: true },
    { key: 'startDate',         label: 'Başlangıç Tarihi',                               sortable: true },
    { key: 'endDate',           label: 'Bitiş Tarihi',                                   sortable: true },
    { key: 'operation',         label: 'İşlem',                                          sortable: true },
    { key: 'minDay',            label: 'Min Gün',                                        sortable: true },
    { key: 'maxDay',            label: 'Max Gün',                                        sortable: true },
    { key: 'id',                label: 'ID',                                             sortable: true },
  ]

  const actions: TableAction<OfferRow>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (row) => onEdit?.(fromRow(row)),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (row) => onDelete?.(fromRow(row)),
    },
  ]

  return (
    <DataTable<OfferRow>
      data={tableData}
      columns={columns}
      actions={actions}
      showPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz teklif bulunamadı'
    />
  )
}

export default OfferTable
